module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnplayart_m.567a6e95d01eebb76f76fd47d24585ba.png";